import PageNotFound from './page-not-found.component';

export default PageNotFound;
